// Global observer for dynamically loaded product recommendations
(function() {
  // Function to initialize all recommendation sliders on the page
  function initAllRecommendationSliders() {
    // Look for all recommendation sections
    const recommendationSections = document.querySelectorAll('product-recommendations');
    
    recommendationSections.forEach(function(section) {
      const sectionId = section.getAttribute('section-id');
      if (sectionId) {
        // Check if slider elements exist
        const slider = document.getElementById('recommendations-slider-' + sectionId);
        const prevBtn = document.getElementById('recommendations-prev-' + sectionId);
        const nextBtn = document.getElementById('recommendations-next-' + sectionId);
        
        if (slider && prevBtn && nextBtn && slider.children.length > 0) {
          // Try to call the section-specific initialization function
          const functionName = 'initRecommendationsSlider' + sectionId.replace(/[-]/g, '_');
          
          if (window[functionName] && typeof window[functionName] === 'function') {
            window[functionName]();
          } else {
            // Try manual initialization as fallback
            let currentIndex = 0;
            const totalItems = slider.children.length;
            
            function updateSlider() {
              const translateX = -currentIndex * 100;
              slider.style.transform = `translateX(${translateX}%)`;
              
              prevBtn.disabled = currentIndex === 0;
              nextBtn.disabled = currentIndex >= totalItems - 1;
              
              prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
              nextBtn.style.opacity = currentIndex >= totalItems - 1 ? '0.5' : '1';
            }
            
            prevBtn.onclick = function() {
              if (currentIndex > 0) {
                currentIndex--;
                updateSlider();
              }
            };
            
            nextBtn.onclick = function() {
              if (currentIndex < totalItems - 1) {
                currentIndex++;
                updateSlider();
              }
            };
            
            // Add touch/swipe support
            let startX = 0;
            
            slider.addEventListener('touchstart', function(e) {
              startX = e.touches[0].clientX;
            });
            
            slider.addEventListener('touchend', function(e) {
              const endX = e.changedTouches[0].clientX;
              const diff = startX - endX;
              
              if (Math.abs(diff) > 50) {
                if (diff > 0 && currentIndex < totalItems - 1) {
                  currentIndex++;
                  updateSlider();
                } else if (diff < 0 && currentIndex > 0) {
                  currentIndex--;
                  updateSlider();
                }
              }
            });
            
            updateSlider();
          }
        }
      }
    });
  }
  
  // Create mutation observer to watch for dynamic content
  const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Check if it's a recommendation section or contains one
          if (node.tagName === 'PRODUCT-RECOMMENDATIONS' || 
              node.querySelector && node.querySelector('product-recommendations')) {
            shouldCheck = true;
          }
          
          // Check if recommendation slider elements were added
          if (node.id && node.id.includes('recommendations-slider-')) {
            shouldCheck = true;
          }
        }
      });
    });
    
    if (shouldCheck) {
      setTimeout(initAllRecommendationSliders, 100);
      setTimeout(initAllRecommendationSliders, 500);
    }
  });
  
  // Start observing the document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Also try initialization on load events
  document.addEventListener('DOMContentLoaded', initAllRecommendationSliders);
  window.addEventListener('load', initAllRecommendationSliders);
  
  // Try multiple times with delays
  setTimeout(initAllRecommendationSliders, 1000);
  setTimeout(initAllRecommendationSliders, 2000);
  setTimeout(initAllRecommendationSliders, 3000);
})();